module.exports = __webpack_public_path__ + "static/media/CT_2019_30452.413d41cc.png";